<script>
import headerImg from '@/assets/images/responsive/home-header.jpg?min=768&max=4800';
import headerMobileImg from '@/assets/images/responsive/home-header-mobile.jpg?min=320&max=768';
import BuyerButton from '@/components/Button';
import ResponsiveImage from '@/components/ResponsiveImage';

export default {
  components: {
    BuyerButton,
    ResponsiveImage,
  },
  data: () => ({
    headerImg,
    headerMobileImg
  }),
};
</script>

<template lang='pug'>
.relative.max-w-10xl.mx-auto
  responsive-image.md_hidden(
    v-if='["sm", "md"].includes($mq)'
    sizes='(min-width: 768px) 0px, 100vw',
    :image-object='headerMobileImg',
    alt-text='Thousands of designs to choose from, express yourself. Shop now.',
  )
  responsive-image(
    v-else,
    sizes='(min-width: 768px) 100vw, 0px',
    :image-object='headerImg',
    alt-text='Thousands of designs to choose from, express yourself. Shop now.',
  )
  .absolute.absolute--center.md_text-center
    .text-3xl.text-white.md_text-lg.xl_text-3xl.md_text-brand-secondary-900.leading-tight.mb-1 Thousands of Designs #[.block.md_inline-block to Choose from]
    .font-monoton.leading-none.mt-1.text-8xl.xl_text-10xl.text-brand.leading-tight.md_leading-none.md_text-brand-secondary-900.md_mt-_5 Express
    .font-monoton.leading-none.text-8xl.xl_text-10xl.text-brand.leading-tight.md_leading-none.md_text-brand-secondary-900 Yourself
    buyer-button.mt-3.md_mt-1.xl_mt-1_5(
      text='SHOP NOW',
      @click.native='$router.push({ name: "marketplace" })',
      @keyup.enter.native='$router.push({ name: "marketplace" })',
    )
</template>

<style>
@import '~import/index';
</style>